export default __webpack_public_path__ + "static/media/federico-beccari.ab3a31e7.jpg";